import { Controller } from "@hotwired/stimulus"

// Highlights the active section in the table of contents based on scroll position
export default class extends Controller {
  static targets = ["link", "content"]

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersection(entries),
      {
        rootMargin: "-20% 0px -60% 0px",
        threshold: [0, 0.25, 0.5, 0.75, 1]
      }
    )

    // Observe all headings in the content
    if (this.hasContentTarget) {
      const headings = this.contentTarget.querySelectorAll("h2[id], h3[id]")
      headings.forEach((heading) => this.observer.observe(heading))
    }

    // Handle hash changes (when clicking TOC links)
    this.hashChangeHandler = () => this.highlightFromHash()
    window.addEventListener("hashchange", this.hashChangeHandler)

    // Initial highlight on page load
    this.highlightFromHash()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
    window.removeEventListener("hashchange", this.hashChangeHandler)
  }

  handleIntersection(entries) {
    // Find the entry that's most visible
    const visibleEntries = entries.filter((entry) => entry.isIntersecting)

    if (visibleEntries.length > 0) {
      // Sort by intersection ratio and get the most visible one
      const mostVisible = visibleEntries.sort(
        (a, b) => b.intersectionRatio - a.intersectionRatio
      )[0]

      this.highlightSection(mostVisible.target.id)
    }
  }

  highlightFromHash() {
    const hash = window.location.hash.slice(1)
    if (hash) {
      this.highlightSection(hash)
    }
  }

  highlightSection(sectionId) {
    if (!sectionId) return

    this.linkTargets.forEach((link) => {
      const linkSection = link.dataset.section

      if (linkSection === sectionId) {
        // Add active styles
        link.classList.add("bg-primary", "text-primary-content", "font-semibold")
        link.classList.remove("hover:bg-base-200")
      } else {
        // Remove active styles
        link.classList.remove("bg-primary", "text-primary-content", "font-semibold")
        link.classList.add("hover:bg-base-200")
      }
    })
  }
}
